<template>
  <div>
    <span>
      {{ isExpanded ? text : shortText }}
      <span v-if="isTruncated">...</span>
    </span>
    <a
      v-if="isTruncated"
      href="#"
      @click.prevent="toggle"
      style="color: blue; margin-left: 5px"
    >
      {{ isExpanded ? 'Read less' : 'Read more' }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ReadMore',
  props: {
    text: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    isTruncated() {
      return this.text.length > this.limit;
    },
    shortText() {
      return this.text.slice(0, this.limit);
    }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/settings/components/ReadMore.vue